import { render, staticRenderFns } from "./kinsfolkCardList.vue?vue&type=template&id=a52070e2&scoped=true&"
import script from "./kinsfolkCardList.vue?vue&type=script&lang=js&"
export * from "./kinsfolkCardList.vue?vue&type=script&lang=js&"
import style0 from "./kinsfolkCardList.vue?vue&type=style&index=0&id=a52070e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52070e2",
  null
  
)

export default component.exports